/* src/app/private/components/enrollment/move-to-admission/move-to-admission.component.scss */
label {
  font-weight: 600;
  margin-bottom: 10px;
}
.requiredValue::after {
  content: "*";
  color: red;
}
/*# sourceMappingURL=move-to-admission.component.css.map */
